import {CustomerReportContext} from '../context'
import {KTCard} from '../../../_metronic/helpers'
import useGetCustomerGroupReport from '../hooks/useGetCustomerGroupReport'
import useGetCustomerTypeReport from '../hooks/useGetCustomerTypeReport'
import CustomerGroupReportTable from '../sections/table/CustomerGroupReportTable'
import CustomerReportsHeader from '../sections/header/CustomerReportsHeader'
import CustomerTypeReportTable from '../sections/table/CustomerTypeReportTable'
import useGetCustomerGroupDropdown from '../hooks/useGetCustomerGroupDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'

function CustomerReport() {
  const {
    reportData: customerGroupData,
    isLoading: isCustomerGroupLoading,
    filters: customerGroupFilters,
    onSortingChange: onCustomerGroupSortingChange,
    onDateChange: onCustomerGroupDateChange,
    onChangeCustomerGroupFilter,
  } = useGetCustomerGroupReport()

  const {
    reportData: customerTypeData,
    isLoading: isCustomerTypeLoading,
    filters: customerTypeFilters,
    onSortingChange: onCustomerTypeSortingChange,
    onDateChange: onCustomerTypeDateChange,
  } = useGetCustomerTypeReport()

  const {
    entityPerformanceChartData,
    isLoading:isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_group')

  const {
    entityPerformanceChartData: customerTypeEntityPerformanceChartData,
    isLoading: isCustomerTypeEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange: onCustomerTypeEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange: onCustomerTypeEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange: onCustomerTypeEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters: customerTypeEntityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('customer_type')

  const {customerGroups, isLoading: isCustomerGroupsLoading} = useGetCustomerGroupDropdown()

  const contextValue = {
    customerGroupData,
    isCustomerGroupLoading,
    customerGroupFilters,
    onCustomerGroupSortingChange,
    onCustomerGroupDateChange,
    onChangeCustomerGroupFilter,

    customerTypeData,
    isCustomerTypeLoading,
    customerTypeFilters,
    onCustomerTypeSortingChange,
    onCustomerTypeDateChange,

    customerGroups,
    isCustomerGroupsLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    customerTypeEntityPerformanceChartData,
    isCustomerTypeEntityPerformanceChartDataLoading,
    onCustomerTypeEntityPerformanceChartIdChange,
    onCustomerTypeEntityPerformanceChartViewChange,
    onCustomerTypeEntityPerformanceChartDateRangeChange,
    customerTypeEntityPerformanceChartFilters,
  }

  return (
    <KTCard>
      <CustomerReportContext.Provider value={contextValue}>
        <CustomerReportsHeader />
        <CustomerGroupReportTable />
        <CustomerTypeReportTable />
      </CustomerReportContext.Provider>
    </KTCard>
  )
}

export default CustomerReport
